import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import AuthButton from "../AuthButton/AuthButton";
import Input from "../Input/Input";
import { Logout, LOGOUTLOADER, POPUP, refreshToken } from "../../Actions/actions";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { toast } from "react-toastify";
import moment from "moment";
import CustomToast from "../CustomToast/CustomToast";

const ReportManagementModal = ({ isOpen, onClose, heading }) => {
  const dispatch = useDispatch();

  const { loginData } = useSelector((state) => state.userReducer);

  const [loader, setLoader] = useState(false);

  const [errors, setErrors] = useState({
    reportName: "",
    reportType: "",
    startDate: "",
    endDate: "",
  });
  const [formData, setFormData] = useState({
    reportName: "",
    reportType: "",
    startDate: "",
    endDate: "",
  });

  const ReportOption = [
    { value: "Client", label: "Client" },
    { value: "Subscription", label: "Subscription" },
    { value: "Transaction", label: "Transaction" },
  ];

  useEffect(() => {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    setFormData({
      startDate: sevenDaysAgo.toISOString().split("T")[0],
      endDate: today.toISOString().split("T")[0],
    });
  }, [isOpen]);

  const validateForm = () => {
    let valid = true;
    let newErrors = {
      reportName: "",
      reportType: "",
      startDate: "",
      endDate: "",
    };

    if (!formData.reportName) {
      newErrors.reportName = "Report name is required";
      valid = false;
    }
    if (!formData.reportType) {
      newErrors.reportType = "This field is required";
      valid = false;
    }
    if (!formData.startDate) {
      newErrors.startDate = "Start date is required";
      valid = false;
    }
    if (!formData.endDate) {
      newErrors.endDate = "End date is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData, "form Data is here");
    if (!validateForm()) return;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(formData);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/reports/generate`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            setFormData({
              reportType: "",
              reportName: "",
              startDate: "",
              endDate: "",
            });
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          setLoader(false);
          console.log("generated report: ", result);
          onClose();
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getAssets = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/asset-types`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: LOGOUTLOADER, payload: true });
          console.log(result);
          dispatch({ type: LOGOUTLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOGOUTLOADER, payload: false });
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssets();
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-gray-900 opacity-50 fixed inset-0" onClick={onClose}></div>

      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[40%] relative z-10">
        <button className="absolute top-7 right-5 text-gray-500 hover:text-gray-700" onClick={onClose}>
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-6">{heading}</h2>

        <form onSubmit={handleSubmit} className="">
          <div className="w-full mr-4 mb-6">
            <Input
              type="text"
              float={true}
              name="Report Name"
              label={"Report Name*"}
              value={formData.reportName}
              onChange={(e) => setFormData({ ...formData, reportName: e.target.value })}
            />
            {errors.reportName && <p className="text-red-500 text-sm">{errors.reportName}</p>}
          </div>

          <div className="-mt-5">
            <DropDownCustom
              selectedValue={ReportOption?.find((option) => option.value === formData.reportType)}
              handleChanges={(e) => {
                setFormData({ ...formData, reportType: e.value });
              }}
              options={ReportOption}
              isSearchable={false}
              label="Report Type*"
              placeholder={"Select Report Type"}
            />
            {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
          </div>

          <div className="flex mt-6">
            <div className="w-full mr-4">
              <Input
                type="date"
                isMinimumDate={false}
                float={true}
                label={"From"}
                value={formData.startDate}
                name="startFrom"
                onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
              />
              {errors.startDate && <p className="text-red-500 text-sm">{errors.startDate}</p>}
            </div>
            <div className="w-full">
              <Input
                type="date"
                name="endTo"
                label="To"
                float
                value={formData.endDate}
                onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
              />
              {errors.endDate && <p className="text-red-500 text-sm">{errors.endDate}</p>}
            </div>
          </div>

          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              onClick={onClose}
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
            />
            {loader ? (
              <Loader />
            ) : (
              <AuthButton width={"20%"} title={"Generate"} className="px-4 py-2 text-white rounded-md" />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportManagementModal;
